import { render } from "./AddLead.vue?vue&type=template&id=44a6a048&scoped=true"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"

import "./AddLead.vue?vue&type=style&index=0&id=44a6a048&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a6a048"]])

export default __exports__